module.exports = __webpack_public_path__ + "media/images/first-championship-mobile-18e2562f2e6996f6bd76b27c553cc2ce.jpg";